// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sh-9";
export var arrowButtonContainer = "_sh-5";
export var arrowButtonIcon = "_sh-6";
export var carouselArrowButton = "_sh-2";
export var carouselElementContainer = "_sh-1";
export var currentSlide = "_sh-8";
export var left = "_sh-3";
export var otherSlide = "_sh-a";
export var productCarouselContainer = "_sh-0";
export var right = "_sh-4";
export var sliderOverflow = "_sh-7";